import moment from "moment";

// Helper for formatting date to "YYYY-MM-DD"
export const formatDate = (date: Date) => moment(date).format("YYYY-MM-DD");

export const createDateWithoutTimezone = (dateStr: string): Date => {
  const [year, month, day] = dateStr. split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const parsePartialUnavailability = (partialUnavailable: {
  [key: string]: [string, string][];
}) => {
  const result: { [key:  string]: { from: string; to: string }[] } = {};

  for (const [dateKey, timeRanges] of Object.entries(partialUnavailable)) {
    result[dateKey] = timeRanges. map(([fromTime, toTime]) => ({
      from:  `${fromTime}:  00`,
      to: `${toTime}:00`,
    }));
  }

  return result;
};

export const timeSlots = Array.from({ length: 24 }, (_, h) => [
  `${h. toString().padStart(2, "0")}:00`,
  `${h.toString().padStart(2, "0")}:30`,
]).flat();

export const formatTime = (time: string, use24Hour: boolean) => {
  if (time === "00:00") {
    return use24Hour ? "00:00" : "Midnight";
  }
  return use24Hour
    ? moment(time, "HH:mm").format("HH:mm")
    : moment(time, "HH:mm").format("h:mm A");
};